export default class DarkMode {

    constructor(selector = '.js-toggle-color a') {

        // Default based on browser - moved to wp_head
        /*
        const savedTheme = localStorage.getItem("theme");
        if(savedTheme) {
            document.querySelector('html').classList.add(savedTheme+"-mode");
        } else {
            const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            if (prefersDark) document.querySelector('html').classList.add("dark-mode");
        }
        */

        // toggle to change
        const btn = document.querySelector(selector);

        btn.addEventListener("click", function(event) {
            event.preventDefault();

            // Toggles the "dark-mode" class on the <body> tag
            document.querySelector('html').classList.toggle("dark-mode");

            // Optional: Save preference to localStorage for future visits
            const theme = document.querySelector('html').classList.contains("dark-mode") ? "dark" : "light";
            localStorage.setItem("theme", theme);
        });
    }

}